module.exports = __webpack_public_path__ + "static/media/logo.26d08f9a.png";